import { type MouseEvent, useMemo } from 'react';

import { GAMMA_DESK_ID } from '@/api/chat/constants';
import FlagIcon from '@/assets/svg/sidebar/flag.svg';
import SettingsIcon from '@/assets/svg/sidebar/settings.svg';
import { useStartTypedThread } from '@/pages/communications-v2/hooks/use-start-typed-thread';
import { getCommunicationContactPath } from '@/pages/communications-v2/utils/get-communication-contact-path';
import { PagePaths } from '@/routes/page-paths';

import { SidebarLink } from './use-get-sidebar-links';

export const useGetSidebarBottomLinks = (): SidebarLink[] => {
  const { start } = useStartTypedThread();

  return useMemo(
    () => [
      { text: 'Settings', href: PagePaths.settings, icon: <SettingsIcon /> },
      {
        text: 'Report',
        href: getCommunicationContactPath({
          recipientType: 'GammaDesk',
          recipientId: GAMMA_DESK_ID,
        }),
        icon: <FlagIcon />,
        onClick: (event: MouseEvent<HTMLAnchorElement>) => {
          event.preventDefault();
          start({
            recipientType: 'GammaDesk',
            recipientId: GAMMA_DESK_ID,
            name: `Bug Report ${new Date().toLocaleDateString()}`,
            type: 'Report',
          });
        },
      },
    ],
    [start],
  );
};
